<template>
  <mc-notification appearance="info" icon="info-circle">
    <slot>
      <p
        tabindex="0"
        role="button"
        @keydown.enter="marketingClickThrough"
        @click="marketingClickThrough"
        v-html="$t('shipments.oceanNotification')"
      />

      <mc-button class="mt-2 mb-4" :label="$t('shipments.oceanButton')" @click="navigateToOceanBooking" />
    </slot>
  </mc-notification>
</template>

<script>
export default {
  name: "MarketingNotification",
  methods: {
    async navigateToOceanBooking() {
      this.$sendGAEvent({
        category: "Component",
        event: "DQCS",
        action: "Click",
        label: {
          data: "SoOceanBookingClick"
        }
      });
      window.location.href = `/book`;
    },
    marketingClickThrough() {
      this.$sendGAEvent({
        category: "Component",
        event: "DQCS",
        action: "Click",
        label: {
          data: "SoOceanLinkClick"
        }
      });
    }
  }
};
</script>
